export default {
  methods: {
   openLink(url) {
    const params = [url, '_blank'];
    this.$store.getters.userDevice === 'd' && params.push('height=600,width=800');
    window.open(...params);
   }
  }
}
